<template>
  <tab-layout>
    <li slot="tabHeading" class="nav-item">
      <a :class="['nav-link', selectedTab === 'details' ? 'active' : '']" href @click.prevent="selectedTab = 'details'" id="details-tab" data-toggle="tab" role="tab" aria-controls="details" :aria-selected="selectedTab === 'details' ? 'true' : 'false'">Details</a>
    </li>
    <li slot="tabHeading" class="nav-item" v-if="memberDetails">
      <a :class="['nav-link', selectedTab === 'membership' ? 'active' : '']" href @click.prevent="selectedTab = 'membership'" id="membership-tab" data-toggle="tab" role="tab" aria-controls="membership" :aria-selected="selectedTab === 'membership' ? 'true' : 'false'">Membership</a>
    </li>
    <li slot="tabHeading" class="nav-item" v-if="memberDetails">
      <a :class="['nav-link', selectedTab === 'financials' ? 'active' : '']" href @click.prevent="selectedTab = 'financials'" id="financials-tab" data-toggle="tab" role="tab" aria-controls="financials" :aria-selected="selectedTab === 'financials' ? 'true' : 'false'">Financials</a>
    </li>
    <li slot="tabHeading" class="nav-item" v-if="memberDetails">
      <a :class="['nav-link', selectedTab === 'history' ? 'active' : '']" href @click.prevent="selectedTab = 'history'" id="history-tab" data-toggle="tab" role="tab" aria-controls="history" :aria-selected="selectedTab === 'history' ? 'true' : 'false'">History</a>
    </li>
    <member-profile-details
      v-if="selectedTab === 'details'"
      @renew="$router.push({ name: 'Member Profile', params: { renewing: true, tab: 'membership' } })"
      :memberDetails="memberDetails"
      slot="tabContent"
      class="tab-pane row mx-0 show active"
      id="details"
      role="tabpanel"
      aria-labelledby="details-tab" />
    <member-profile-membership
      :my="false"
      :memberDetails="primaryMember"
      v-if="selectedTab === 'membership'"
      slot="tabContent"
      :class="['tab-pane show active', (userRole === 'Admin' || userRole === 'SuperAdmin') ? 'row mx-0' : 'bg-white rounded mb-4 p-3 p-sm-4 col-12 col-xl-9']"
      id="membership"
      role="tabpanel"
      aria-labelledby="membership-tab" />
    <member-profile-financials
      :memberID="memberDetails.id"
      v-if="selectedTab === 'financials'"
      slot="tabContent"
      class="tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active"
      id="financials"
      role="tabpanel"
      aria-labelledby="financials-tab" />
    <member-profile-history
      v-if="selectedTab === 'history'"
      :memberID="memberDetails.id"
      :membership_options="memberDetails.membership_options"
      slot="tabContent"
      class="tab-pane col-md-11 col-lg-10 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active"
      id="history"
      role="tabpanel"
      aria-labelledby="history-tab" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import tabLayout from '@/components/TabLayout'
import GETSTORE from '@/store/memberProfileStore.js'
import memberProfileDetails from '@/views/Members/Tabs/Details'
import memberProfileFinancials from '@/views/Members/Tabs/Financials'
import memberProfileMembership from '@/views/Members/Tabs/Membership'
import memberProfileHistory from '@/views/Members/Tabs/MembershipHistory'

export default {
  name: 'MemberProfileChild',
  props: ['details'],
  mixins: [GETSTORE],
  components: {
    'tab-layout': tabLayout,
    'member-profile-details': memberProfileDetails,
    'member-profile-membership': memberProfileMembership,
    'member-profile-financials': memberProfileFinancials,
    'member-profile-history': memberProfileHistory
  },
  data() {
    return {
      selectedTab: 'details',
      child: true,
      primaryMember: this.$store.state.viewedMember,
      userRole: localStorage.role
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Members/Profile/MemberProfileChild.vue